/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { createResize } from '../../factoriesAny.js';
export var resizeDependencies = {
  matrixDependencies: matrixDependencies,
  createResize: createResize
};